// JS `%` is a remainder, not modulo operator, hence providing own helper to calculate modulo
export const modulo = (n: number, m: number) => ((n % m) + m) % m;
